<bodyanalytics-field-label
  [for]="inputId()"
  [text]="label()"
  [required]="required()"
  [hint]="hint()"></bodyanalytics-field-label>

<div class="field-select">
  <select
    class="field-select__control"
    [class.field-select__control--invalid]="invalid()"
    [class.field-select__control--placeholder]="!hasMatch()"
    [id]="inputId()"
    [required]="required()"
    [disabled]="disabled()"
    [attr.aria-invalid]="invalid() ? 'true' : null"
    [attr.aria-describedby]="describedBy()"
    (change)="handleChange($event)"
    (blur)="handleBlur()">
    <option value="" [selected]="!hasMatch()" [disabled]="required()">{{ placeholder() }}</option>
    @for (opt of options(); track opt.value) {
      <option [value]="opt.value" [selected]="isSelected(opt.value)" [disabled]="opt.disabled">{{ opt.label }}</option>
    }
  </select>
  <i class="bx bx-chevron-down field-select__chevron" aria-hidden="true"></i>
</div>

@if (error(); as e) {
  <p class="field-select__error" role="alert" [id]="errorId()">
    <i class="bx bx-error-circle" aria-hidden="true"></i>
    {{ e }}
  </p>
}
